import React, { useState } from 'react';
import Loading from '../../../Components/Loading';

const RenderLoading: React.FC = () => {
	return <Loading />;
};

export default function useLoading(defaultValue: boolean = false) {
	const [isLoading, setIsLoading] = useState(defaultValue);

	return {
		isLoading,
		setIsLoading,
		RenderLoading,
	};
}
